import React, { useEffect, useState } from "react";
import { logo, logoGray, pendingIcon } from "../assets/images";
import {
  ApplyCouponCode,
  GetCheckoutData,
  paymentFailureService,
  paymentSuccessService,
} from "../api/Register";
import Footer from "./common/Footer";
import { useNavigate, useParams } from "react-router-dom";
import { formatToCurrency, loadScript } from "../utils/commonFunction";
import { RAZORPAY_KEY } from "../config/constant";
import { tostE, tostS, tostW } from "../config/tostConfig";
import { GetPaymentData } from "../api/common";
import Loading from "./ui/Loading";

export default function Checkout() {
  const { user_id } = useParams();
  const navigate = useNavigate();
  const [checkoutData, setCheckoutData] = useState({});
  const [check, setCheck] = useState(false);
  const [loading, setLoading] = useState(false);
  const [getDataLoading, setGetDataLoading] = useState(false);
  const [inputs, setInputs] = useState({ couponCode: "", applyCoupon: false });

  const getData = async (applyCoupon = false) => {
    setGetDataLoading(true);
    try {
      let res = {};
      if (applyCoupon) {
        res = await ApplyCouponCode(user_id, inputs.couponCode);
      } else {
        res = await GetCheckoutData(user_id);
      }
      if (res.status === 200 && res.data.success) {
        if (applyCoupon) {
          let coupon_data = {};
          if (res.data && res.data.data && res.data.data.coupon) {
            coupon_data = res.data.data.coupon;
            if (!coupon_data?.status) {
              tostE(coupon_data?.msg || "Coupon Expired");
              setInputs({ couponCode: "", applyCoupon: false });
            }
          }
          if (coupon_data?.status) {
            setCheckoutData(res.data.data);
            tostS("Coupon Applied Successfully.");
          }
        }
        if (
          res.data &&
          res.data.data &&
          res.data.data.plan_history &&
          res.data.data.plan_history.cancelled
        ) {
          navigate(`/application-cancelled/${user_id}`, { replace: true });
        }
        if (!applyCoupon) setCheckoutData(res.data.data);
      } else if (
        res.data &&
        res.data.data &&
        res.data.data.plan_history &&
        res.data.data.plan_history.cancelled
      ) {
        navigate(`/application-cancelled/${user_id}`, { replace: true });
      } else if (
        res.data &&
        !res.data.success &&
        res.data?.payment_link_expired
      ) {
        navigate(`/payment-expired`, { replace: true });
      } else {
        // const orderData = res.data.order_data
        navigate(`/payment-received`, { replace: true });
      }
    } catch (error) {
      console.log(error);
      navigate("/");
    } finally {
      setGetDataLoading(false);
    }
  };

  useEffect(() => {
    getData();
    loadScript("https://checkout.razorpay.com/v1/checkout.js");
  }, []); // eslint-disable-line

  const handleMakePayment = async () => {
    if (!check) {
      tostW("Please Confirm Details are correct");
      return;
    }
    setLoading(true);
    try {
      let coupon_code = inputs.applyCoupon ? inputs.couponCode : "";
      const res = await GetPaymentData(
        user_id,
        checkoutData.total,
        "register",
        coupon_code
      );
      if (res.status === 200 && res.data.success) {
        const respData = res.data.data;

        const options = {
          key: RAZORPAY_KEY, // Replace with your Razorpay key ID
          amount: respData.total_amount * 100, // Amount in the smallest currency unit (e.g., paise for INR)
          currency: "INR",
          name: "EEMA",
          description: "Event & Entertainment Management Association",
          image: logo,
          order_id: respData.unique_order_id, // Replace with your generated order ID
          handler: async function (response) {
            const sendData = {
              ...response,
              history_id: checkoutData.plan_history.id,
              history_type: "new",
            };
            setGetDataLoading(true);
            try {
              const res = await paymentSuccessService(sendData);
              if (res.status === 200 && res.data.success) {
                tostS(`Payment successful!`);
                navigate(
                  `/register/user/payment-success/${respData.unique_order_id}`,
                  { replace: true }
                );
              } else {
                tostE(res.message);
              }
            } catch (error) {
              tostE(error.message);
            } finally {
              setGetDataLoading(false);
            }
          },
          prefill: {
            name: respData.name,
            email: respData.email,
            contact: respData.mobile_number,
          },
          notes: {
            regarding: "Registration Fee",
          },
          theme: {
            color: "#D37C51",
          },
        };
        const rzp = new window.Razorpay(options);
        rzp.on("payment.failed", async function (response) {
          setGetDataLoading(true);
          try {
            const res = await paymentFailureService({
              ...response.error,
              history_id: checkoutData.plan_history.id,
            });
            if (res.status === 200 && res.success) {
              tostE("Payment failed. Please try again.");
            }
          } catch (error) {
            console.log(error);
          } finally {
            setGetDataLoading(false);
          }
        });

        rzp.open();
      }

      if(res.status === 200 && !res.data.success && res.data?.payment_link_expired){
        navigate(`/payment-expired`, { replace: true });
      }

    } catch (error) {
      tostE("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const applyCoupon = async () => {
    getData(true);
  };

  useEffect(() => {
    if (inputs.applyCoupon && inputs.couponCode) {
      applyCoupon();
    }
  }, [inputs]); // eslint-disable-line

  return (
    <>
      {getDataLoading && <Loading />}
      <div className="customContainer">
        <div className="headingTexts ">
          <h2>Checkout</h2>
          <p>
            You are applying under{" "}
            <span style={{ fontWeight: "600" }}>{checkoutData.Plan_Name}</span>
          </p>
        </div>

        <div className="row">
          <div className="col-md-7 col-lg-7 col-xl- col-xxl-7">
            <div className="orderDetails">
              <p>Please confirm your order details & click on continue.</p>
              <div className="userdetailsCard">
                {checkoutData.plan_history && (
                  <div className="dataRow">
                    <div>Member Name </div>
                    <div>{checkoutData.plan_history.company_name}</div>
                  </div>
                )}
                <div className="dataRow">
                  <div>Authorized Person</div>
                  <div>{checkoutData.Name}</div>
                </div>
                <div className="dataRow">
                  <div>Email </div>
                  <div>{checkoutData.Email}</div>
                </div>
                <div className="dataRow">
                  <div>Category </div>
                  <div>{checkoutData.Plan_Name}</div>
                </div>

                <div className="dataRow">
                  <div>Joining Fee </div>
                  <div>
                    <span style={{ fontFamily: "arial" }}>₹ </span>
                    {formatToCurrency(checkoutData.Joining_Fees)}
                  </div>
                </div>
                <div className="dataRow">
                  <div>Annual Fee </div>
                  <div>
                    <span style={{ fontFamily: "arial" }}>₹ </span>
                    {formatToCurrency(checkoutData.Annual_Fees)}
                  </div>
                </div>
                <div className="dataRow">
                  <div>GST (18%)</div>
                  <div>
                    <span style={{ fontFamily: "arial" }}>₹ </span>
                    {formatToCurrency(checkoutData.gst)}
                  </div>
                </div>
                <div className="dataRow">
                  <div>Add Coupon</div>

                  <div className="form-group">
                    <div className={"verifyLabel "}>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Coupon Code"
                        name="couponCode"
                        disabled={inputs.applyCoupon}
                        value={inputs.couponCode.toUpperCase()}
                        onChange={(e) => {
                          setInputs((prev) => ({
                            ...prev,
                            couponCode: e.target.value,
                          }));
                        }}
                      />
                      <span className="form-check numberCheck">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="inlineCheckbox1"
                          name="applyCoupon"
                          checked={inputs.applyCoupon}
                          onChange={(e) => {
                            if (inputs.applyCoupon && !e.target.checked) {
                              getData();
                            }
                            if (e.target.checked && !inputs.couponCode) {
                              tostW("Please enter a coupon code");
                            } else {
                              setInputs((prev) => ({
                                ...prev,
                                applyCoupon: e.target.checked,
                              }));
                            }
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="inlineCheckbox1"
                        >
                          Apply Coupon
                        </label>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-5 col-lg-5 col-xl-5 offset-xl-1 col-xxl-4 offset-xxl-1">
            <div className="text-end">
              {" "}
              <img src={logoGray} alt="" />{" "}
            </div>

            <div className="totalAmount">
              <div>
                {" "}
                <strong>
                  <span style={{ fontFamily: "arial" }}>₹ </span>
                  {formatToCurrency(checkoutData.total)}
                </strong>
              </div>
              <p>Amount Payable</p>
            </div>
          </div>
        </div>
      </div>
      <Footer
        hideBackButton
        className="justify-content-end"
        isNextAllowed={!loading}
        isBackAllowed={false}
        nextButtonText="Make Payment"
        nextButtonAction={() => {
          setCheck(true);
        }}
      />
      {check && (
        <div
          className={"modal fade show confirmationModal"}
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className={"modal-header "}>
                <h5 className="modal-title">Confirm</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => {
                    setCheck(false);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20.055"
                    height="20.055"
                    viewBox="0 0 20.055 20.055"
                  >
                    <path
                      id="Icon_metro-cross"
                      data-name="Icon metro-cross"
                      d="M19.424,15.592h0l-5.16-5.16,5.16-5.16h0a.533.533,0,0,0,0-.752L16.986,2.083a.533.533,0,0,0-.752,0h0l-5.16,5.16-5.16-5.16h0a.533.533,0,0,0-.751,0L2.726,4.521a.533.533,0,0,0,0,.751h0l5.16,5.16-5.16,5.16h0a.533.533,0,0,0,0,.751l2.437,2.437a.533.533,0,0,0,.752,0h0l5.16-5.16,5.16,5.16h0a.533.533,0,0,0,.751,0l2.437-2.437a.533.533,0,0,0,0-.751Z"
                      transform="translate(-1.047 -0.405)"
                      fill="#333"
                      stroke="#fff"
                      strokeWidth="3"
                    />
                  </svg>
                </button>
              </div>
              <div className="modal-body">
                <div className="text-center">
                  <img className="mb-3" src={pendingIcon} alt="" />
                  <p>
                    By clicking Proceed, I hereby confirm the accuracy of
                    details given above.
                  </p>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className={"btn back btn-primary"}
                  onClick={() => {
                    setCheck(false);
                  }}
                >
                  Review
                </button>
                <button
                  type="button"
                  className={"btn backbtn btn-primary"}
                  onClick={() => {
                    handleMakePayment();
                  }}
                  disabled={loading}
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
